







import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import Login from './Login.vue'
import Ping from 'ping.js'


firebase.database.Reference::read = (path) ->
  this.once('value').then (snap) -> snap.val()


firebase.initializeApp(
  apiKey: 'AIzaSyDXzqAiDDFL2qMjoqbR7Lriqg3lze7cBZo'
  authDomain: 'redka-games.firebaseapp.com'
  databaseURL: 'https://redka-games.firebaseio.com'
  projectId: 'redka-games'
  storageBucket: ''
  messagingSenderId: '178199504927')

window.firebase = firebase
db = firebase.database()


class ServersCollection
  constructor: (game, $set, filter = -> true) ->
    @servers = {}
    @regions = {}
    @ping = new Ping

    @ref = db.ref("servers/#{ game }")
    @ref.on 'child_added', (snap) =>
      region = snap.key

      servers = @servers[region]
      servers = $set @servers, region, {} if not servers

      if not @regions[region]?
        $set @regions, region, ping: '-', url: "https://#{ region }.redka.games"
        @reportPing(@regions[region])

      snap.ref.on 'child_added', (snap) ->
        server = snap.val()
        if filter(server)
          server.url = "https://#{ game }.redka.games/#{ region }:#{ snap.key }"
          $set servers, snap.key, server

      snap.ref.on 'child_changed', (snap) ->
        server = servers[snap.key]
        return if not server?
        for key, val of snap.val()
          $set(server, key, val) if not server[key]?
          server[key] = val
        null

  reportPing: (region, ping = @ping) ->
    @_pingIndex ?= 0
    await Promise.delay(++@_pingIndex * 500)
    ms = 2000
    maxTooHighCount = 2
    setTimeout fn = ->
      ms = Math.min(ms + 500, 10000)
      ping.ping region.url, (_, data) ->
        if data < 300 or --maxTooHighCount < 0
          region.ping = data
        setTimeout fn, ms
    , ms


export default
  name: 'Firebase'

  props: ['with-login']

  components: { Login }

  data: -> {}

  mounted: ->
    @$emit 'mounted', { ServersCollection }

